import React from 'react';
import classNames from 'classnames';
import { ImageType } from '@types';
import Image from '@components/Image';
import type { TTSConfigItem } from './ttsConfig';

type Props = {
  type: TTSConfigItem['avatar'];
  className?: string;
};

const avatarMap: Readonly<Record<Props['type'], string>> = {
  male: '/imgs/tts-male.426ed2d3c415725900a7e6f4a17f1848.png',
  female: '/imgs/tts-female.c228b47a86fdcdbc13ed79c2aa5cfabf.png',
};

export function TTSAvatar({ type, className }: Props) {
  const url = avatarMap[type];
  return (
    <Image
      src={url}
      type={ImageType.sysMedia}
      className={classNames('h-32 w-32', className)}
    />
  );
}
